import { ConsoleTransport, LogLayer } from "loglayer"

export type LogContext = {
  readonly app:
    | "landing"
    | "invest"
    | "portal"
    | "nexus"
    | "investor"
    | "api"
    | "mcp-knowledge"
    // CivalaOS Mode 6 packages + processes (PR-0.x). Added as each lands.
    | "mcp-clients"
    | "fi-runtime"
    | "pdos-workflows"
    | "pdos-runtime"
    | "migrator"
  readonly companyId?: string
  readonly userId?: string
  readonly requestId?: string
}

export const createLogger = (context: LogContext): LogLayer => {
  const log = new LogLayer({
    transport: new ConsoleTransport({
      logger: console,
    }),
    contextFieldName: "context",
    metadataFieldName: "metadata",
  })
  return log.withContext(context)
}
